// payment-margin-wrapper-desktop.js
;(({ $, $$ }) => {
    const expandedClass = 'payment-margin-wrapper-desktop_expanded'
    const desktopMargin = $('.payment-margin-wrapper-desktop')
    if (!desktopMargin) { return }
    const desktopMarginHeader = $('.payment-margin-wrapper-desktop__header')
    if (!desktopMarginHeader) { return }

    desktopMarginHeader.addEventListener('click', event => {
        event.preventDefault()

        desktopMargin.classList.toggle(expandedClass)
    })
})(CNS);

;(({ $, $$ }) => {
    const shownClass = 'payment-margin-wrapper-mobile_shown'
    const mobileMargin = $('.payment-margin-wrapper-mobile')
    if (!mobileMargin) { return }
    const desktopMarginHeader = $('.payment-margin-wrapper-mobile__header')
    if (!desktopMarginHeader) { return }

    const showButton = $('.lead-payment-all__mobile-margin-button')
    if (!showButton) { return }

    desktopMarginHeader.addEventListener('click', event => {
        event.preventDefault()

        mobileMargin.classList.remove(shownClass)
    })

    showButton.addEventListener('click', event => {
        event.preventDefault()

        mobileMargin.classList.add(shownClass)
    })
})(CNS);

// set data
;(({ $, $$ }) => {
    CNS.$fns.setPaymentMargin = function(planPrim, planSec, expPrim, expSec, factPrim, factSec) {
        const margin = $('#payment-margin')
        if (!margin) { return }

        const pp =  $('#payment-margin-plan-primary')
        const ps =  $('#payment-margin-plan-secondary')
        const ep =  $('#payment-margin-expect-primary')
        const es =  $('#payment-margin-expect-secondary')
        const fp =  $('#payment-margin-fact-primary')
        const fs =  $('#payment-margin-fact-secondary')
        
        pp.innerText = planPrim
        ps.innerText = planSec
        ep.innerText = expPrim
        es.innerText = expSec
        fp.innerText = factPrim
        fs.innerText = factSec
    }
})(CNS);